var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppReviewedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10C21.433 10 23 8.433 23 6.5C23 4.567 21.433 3 19.5 3C17.567 3 16 4.567 16 6.5C16 8.433 17.567 10 19.5 10Z",
    stroke: "#14142B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11L22 9",
    stroke: "#14142B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57947 8.07739C8.48843 8.07739 10.075 6.57024 10.075 4.66369C10.075 2.75714 8.48843 1.25 6.57947 1.25C4.67051 1.25 3.08398 2.75714 3.08398 4.66369C3.08398 6.57024 4.67051 8.07739 6.57947 8.07739Z",
    stroke: "#14142B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57581 15.5145C7.90804 15.5145 9.14818 15.3062 10.0827 14.9436C10.5476 14.7631 10.975 14.5299 11.2991 14.2325C11.6237 13.9347 11.9016 13.5153 11.9016 12.9887C11.9016 12.4621 11.6237 12.0427 11.2991 11.7448C10.975 11.4475 10.5476 11.2142 10.0827 11.0338C9.14818 10.6711 7.90804 10.4629 6.57581 10.4629C5.24357 10.4629 4.00344 10.6711 3.06888 11.0338C2.604 11.2142 2.17658 11.4475 1.85254 11.7448C1.52793 12.0427 1.25 12.4621 1.25 12.9887C1.25 13.5153 1.52793 13.9347 1.85254 14.2325C2.17658 14.5299 2.604 14.7631 3.06888 14.9436C4.00344 15.3062 5.24357 15.5145 6.57581 15.5145Z",
    stroke: "#14142B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppReviewedIcon);
export default __webpack_public_path__ + "static/media/AppReviewedIcon.0f6b2ef5b1ba632ed4b4886e197e8ada.svg";
export { ForwardRef as ReactComponent };